import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { spaceXL, space6XL, scale020, scale220 } from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  margin-bottom: calc(${scale020} + ${scale220});

  @media ${mediaConfined} {
    margin-bottom: ${space6XL};
  }
`;

export const Title = styled(Headline)`
  margin-bottom: ${spaceXL};
`;

export const Text = styled(BodyCopy)`
  margin-bottom: calc(2 * ${spaceXL});
`;
